#@export GliveBooking.Presenters.PricePicker

class GliveBooking.Presenters.PricePicker extends BookingV2.Presenters.Picker

  module: 'glive-booking'

  toHash: ->
    hash = BookingV2.Presenters.Picker.prototype.toHash.apply(this, arguments)
    if @selected()?
      hash.selectedPrice =
        price: @selected().getFormattedPrice()
    hash.isTouch = @collection.meta('isTouch')
    hash
